import React, { useState } from 'react';
import './UserPage2.css';
import CommonFormFields from '../../../Forms/CommonFormFields';


type propsType = {
  formData: {
    [key: string]: any;
  };
  formState2:any;
  handleFormChange2:(value: any, key: string, id: any, option: any, code: any, compositeRoleId?:any)=>void;
  onInputChange?:(value:string, key:string) => any;
  forceDistrictEnabled?: boolean;
};

const UserPage2 = ({ formData,formState2,handleFormChange2, onInputChange, forceDistrictEnabled = false }: propsType) => {
  return (
    <div className="user_details_form_page2">
      <form className="form_container_user_details2 create_user_user_details_wrapper">
        <CommonFormFields
          formData={formData}
          formState={formState2}
          handleFormChange={handleFormChange2}
          onInputChange={onInputChange}
          forceDistrictEnabled={forceDistrictEnabled}
        />
      </form>
    </div>
  );
};
export default UserPage2;
